import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Trang chủ Ezy. Mã nghiệp vụ, tên riêng và dữ liệu mẫu không dịch.
addMessages('vi', {
  'home.later': 'Chưa mở ở bản này', 'home.doneRow': 'Xong', 'home.soon': '{m} · chưa mở ở bản này',
  'home.title': 'Trang chủ', 'home.sub': 'Thứ Năm, {d} · Chào {n} · {r}', 'home.gate.block': 'Chặn', 'home.gate.warn': 'Cảnh báo', 'home.density': 'Mật độ hiển thị', 'home.dense.std': 'Chuẩn', 'home.dense.tight': 'Gọn',
  'home.tool.clock': 'Chấm công', 'home.tool.util': 'Tiện ích', 'home.tool.layout': 'Sửa bố cục Trang chủ', 'home.tool.layoutShort': 'Sửa bố cục',
  'home.tool.noti': 'Thông báo', 'home.tool.notiN': 'Thông báo, {n} chưa đọc', 'home.tool.dark': 'Giao diện tối', 'home.tool.task': 'Việc & Duyệt', 'home.quote': 'Báo giá',
  'home.kpi.noData': 'chưa có dữ liệu kỳ này', 'home.kpi.target': '{k}: {v} {u} chỉ tiêu 100%', 'home.kpi.hist': '{k} {v} {u} · 6 kỳ gần nhất: {h}',
  'home.pick': 'Chọn {t}', 'home.due': 'Hạn {d}', 'home.ext': 'Gia hạn 4 giờ làm việc · {x}', 'home.extDone': 'Đã gia hạn +4 giờ làm việc', 'home.more': 'Thao tác khác: {t}',
  'home.my': 'Việc của tôi', 'home.myCount': '{n} mở · {o} quá hạn', 'home.multi': 'Chọn nhiều', 'home.note': 'Ghi nhớ',
  'home.expandLabel': 'Mở rộng Việc của tôi', 'home.expand': 'Mở rộng', 'home.status': 'Trạng thái việc',
  'home.open': 'Đang mở {n}', 'home.done': 'Đã xong {n}', 'home.findLabel': 'Tìm việc', 'home.findPh': 'Tìm việc, job, khách…', 'home.filter': 'Lọc',
  'home.noneDone': 'Chưa có việc xong.', 'home.doneN': '{n} việc đã xong trong kỳ.', 'home.noMatch': 'Không có việc khớp bộ lọc.', 'home.noToday': 'Không có việc nào hôm nay.',
  'home.seeMore': 'Xem thêm {n} việc ›',
  'home.brief': 'Tóm tắt đầu ngày', 'home.briefSrc': 'Ask HANA · 07:30', 'home.askHana': 'Hỏi Hana', 'home.briefNone': 'Chưa có tóm tắt hôm nay.', 'home.noTaskToday': 'Không có việc hôm nay',
  'hn.ap.k.all': 'Tất cả',
  'hn.ap.k.money': 'Tiền & công nợ',
  'hn.ap.k.hr': 'Nhân sự',
  'hn.ap.k.other': 'Khác',
  'hn.ap.d.ok': '✓ Đã đồng ý',
  'hn.ap.d.no': 'Đã từ chối',
  'hn.ap.d.ask': 'Đã hỏi thêm',
  'hn.ap.sumOld': '{n} phiếu · cũ nhất {d} ngày',
  'hn.ap.sum': '{n} phiếu',
  'hn.ap.bySeat': 'Theo ghế',
  'hn.ap.allSeats': 'Mọi ghế',
  'hn.ap.power': ' quyền',
  'hn.ap.expand': 'Mở rộng Duyệt chờ tôi',
  'hn.ap.kindL': 'Loại phiếu',
  'hn.ap.findL': 'Tìm phiếu',
  'hn.ap.findPh': 'Tìm phiếu…',
  'hn.ap.bulk': 'Duyệt hàng loạt',
  'hn.ap.picked': 'Đã chọn {n} phiếu',
  'hn.ap.noBulk': '{n} phiếu cần mở từng phiếu, không tính vào duyệt hàng loạt',
  'hn.ap.nextStep': 'Mỗi phiếu chuyển tiếp sang bước kế của nó',
  'hn.ap.rejectN': 'Từ chối {n}',
  'hn.ap.agreedN': 'Đã đồng ý {n} phiếu',
  'hn.ap.agreeN': 'Đồng ý {n} phiếu',
  'hn.ap.noMatch': 'Không có phiếu khớp bộ lọc.',
  'hn.ap.none': 'Không có phiếu nào chờ bạn duyệt.',
  'hn.ap.openSrc': 'Mở chứng từ gốc',
  'hn.ap.by': 'đề nghị',
  'hn.ap.step': 'Bước {i}/{n}',
  'hn.ap.by2': 'Người đề nghị',
  'hn.ap.sentAt': 'Gửi lúc',
  'hn.ap.seeMore': 'Xem thêm {n} phiếu ›',
});
addMessages('en', {
  'home.doneRow': 'Done', 'home.later': 'Not available in this version', 'home.soon': '{m} · not available in this version',
  'home.title': 'Home', 'home.sub': 'Thursday, {d} · Hi {n} · {r}', 'home.gate.block': 'Blocked', 'home.gate.warn': 'Warning', 'home.density': 'Display density', 'home.dense.std': 'Standard', 'home.dense.tight': 'Compact',
  'home.tool.clock': 'Time clock', 'home.tool.util': 'Utilities', 'home.tool.layout': 'Edit Home layout', 'home.tool.layoutShort': 'Edit layout',
  'home.tool.noti': 'Notifications', 'home.tool.notiN': 'Notifications, {n} unread', 'home.tool.dark': 'Dark theme', 'home.tool.task': 'Tasks & Approvals', 'home.quote': 'Quote',
  'home.kpi.noData': 'no data this period', 'home.kpi.target': '{k}: {v} {u} target 100%', 'home.kpi.hist': '{k} {v} {u} · last 6 periods: {h}',
  'home.pick': 'Select {t}', 'home.due': 'Due {d}', 'home.ext': 'Extend 4 working hours · {x}', 'home.extDone': 'Extended +4 working hours', 'home.more': 'More actions: {t}',
  'home.my': 'My tasks', 'home.myCount': '{n} open · {o} overdue', 'home.multi': 'Select multiple', 'home.note': 'Note',
  'home.expandLabel': 'Expand My tasks', 'home.expand': 'Expand', 'home.status': 'Task status',
  'home.open': 'Open {n}', 'home.done': 'Done {n}', 'home.findLabel': 'Search tasks', 'home.findPh': 'Search tasks, jobs, customers…', 'home.filter': 'Filter',
  'home.noneDone': 'No completed tasks.', 'home.doneN': '{n} tasks completed this period.', 'home.noMatch': 'No tasks match the filter.', 'home.noToday': 'No tasks today.',
  'home.seeMore': 'See {n} more ›',
  'home.brief': 'Morning brief', 'home.briefSrc': 'Ask HANA · 07:30', 'home.askHana': 'Ask Hana', 'home.briefNone': 'No brief today.', 'home.noTaskToday': 'No tasks today',
});
addMessages('vi', {
  'hn.dl.title0': 'Tôi đang thay', 'hn.dl.expandL': 'Mở rộng Tôi đang thay', 'hn.dl.for': 'Thay cho {k}', 'hn.dl.on': 'Đang hiệu lực', 'hn.dl.ready': 'Sẵn sàng',
  'hn.dl.appr': 'quyền duyệt: {a}', 'hn.doneT': 'Xong: {t}', 'hn.reopen': 'Mở lại {c}', 'hn.dl.doneFor': 'Đã xong {c} (thay {k})', 'hn.dl.sub': 'thay {k}',
  'hn.ap.title': 'Duyệt chờ tôi',
  'hn.ap.seat': 'Người duyệt theo ghế · ghế trống leo lên cấp trên',
  'hn.ap.allKinds': 'Mọi loại phiếu',
  'hn.ap.unpick': 'Bỏ chọn',
  'hn.ap.pickAllL': 'Chọn tất cả phiếu đang hiện',
  'hn.ap.pickAll': 'Chọn tất cả',
  'hn.ap.ask': 'Hỏi thêm',
  'hn.reject': 'Từ chối',
  'hn.agreed': 'Đã đồng ý · {k}',
  'hn.agree': 'Đồng ý',
  'hn.dl.title': 'Tôi đang thay · uỷ quyền',
  'hn.dl.active': '{n} uỷ quyền đang nhận',
  'hn.dl.absentDone': 'Đã báo vắng hôm nay · backup nhận việc từ 09:14',
  'hn.dl.absent': 'Báo vắng hôm nay',
  'hn.dl.absentNow': 'Đang báo vắng hôm nay · backup nhận việc từ 09:14',
  'hn.dl.undone': 'Đã huỷ báo vắng · việc quay về bạn',
  'hn.dl.cancel': 'Huỷ báo vắng',
  'hn.dl.none': 'Bạn không đang thay ai.',
  'hn.dl.period': 'Việc trong kỳ',
  'hn.overdue': 'Quá hạn',
  'hn.doneL': 'Đã xong',
  'hn.dl.born': 'Việc phát sinh trong kỳ thay · KPI tính cho người thay',
  'hn.dk.ask': 'Hỏi Hana ›',
  'hn.dk.deleg': 'Uỷ quyền: Đang thay TUANNT, PHONGNT · 6 việc',
  'hn.dk.mailL': 'Mở mail {m}',
  'hn.open': 'Mở',
  'hn.dk.noNoti': 'Không có thông báo.',
  'hn.dk.readAllDone': 'Đã đánh dấu đã đọc tất cả',
  'hn.dk.noAp': 'Không có phiếu nào chờ bạn duyệt.',
  'hn.dk.approve': 'Duyệt',
  'hn.gv.title': 'Việc tôi giao / theo dõi',
  'hn.gv.open': 'đang mở',
  'hn.gv.assign': 'Giao việc',
  'hn.gv.none': 'Chưa có việc nào ở đây.',
  'hn.gv.recalled': 'Đã thu hồi {c} về bạn',
  'hn.gv.recall': 'Thu hồi',
  'hn.nw.kick': 'TIN NỘI BỘ',
  'hn.nw.next': 'Tin sau',
  'hn.nw.prev': 'Tin trước',
  'hn.nw.openBanner': 'Mở banner',
  'hn.nw.none': 'Không có tin cho đối tượng / danh mục này.',
  'hn.nw.write': 'Soạn tin',
  'hn.sd.cal': 'Lịch hôm nay',
  'hn.sd.calSub': 'việc của tôi + cut-off',
  'hn.sd.today': 'Hôm nay',
  'hn.sd.h48': '48 giờ',
  'hn.sd.noMark': 'Không có mốc nào trong khoảng này.',
  'hn.sd.sla': 'SLA & quá hạn',
  'hn.sd.slaSub': 'việc của tôi · 30 ngày',
  'hn.sd.byGrp': 'Việc mở theo nhóm',
  'hn.sd.esc': 'Đang leo thang lên tôi',
  'hn.sd.src': 'Việc theo nguồn',
  'hn.sd.srcSub': 'việc mở',
  'hn.sd.noOpen': 'Không có việc mở.',
  'hn.sd.noItem': 'Không có mục nào cần xử lý.',
  'hn.tm.title': 'Việc của team · theo người',
  'hn.tm.sum': '{n} người · {o} quá hạn',
  'hn.tm.ok': 'trong hạn',
  'hn.tm.over': 'quá hạn',
  'hn.tm.wait': 'chờ',
  'hn.tm.none': 'Chưa có dữ liệu team.',
  'hn.tm.openL': 'mở',
  'hn.tm.late': 'trễ',
  'hn.tm.of': 'Việc của {p}',
  'hn.tm.closeL': 'Đóng việc của người',
  'hn.tm.reDone': 'đã giao lại',
  'hn.tm.reTip': 'Đã giao lại',
  'hn.tm.re': 'Giao lại…',
});
addMessages('en', {
  'hn.dl.title0': 'Covering', 'hn.dl.expandL': 'Expand Covering for others', 'hn.dl.for': 'Covering for {k}', 'hn.dl.on': 'Active', 'hn.dl.ready': 'Ready',
  'hn.dl.appr': 'approval rights: {a}', 'hn.doneT': 'Done: {t}', 'hn.reopen': 'Reopened {c}', 'hn.dl.doneFor': 'Done {c} (covering {k})', 'hn.dl.sub': 'covering {k}',
  'hn.ap.title': 'Awaiting my approval',
  'hn.ap.seat': 'Approver by seat · vacant seat escalates to the next level',
  'hn.ap.allKinds': 'All request types',
  'hn.ap.unpick': 'Clear selection',
  'hn.ap.pickAllL': 'Select all visible requests',
  'hn.ap.pickAll': 'Select all',
  'hn.ap.ask': 'Ask more',
  'hn.reject': 'Reject',
  'hn.agreed': 'Approved · {k}',
  'hn.agree': 'Approve',
  'hn.dl.title': 'Covering for others · delegation',
  'hn.dl.active': '{n} active delegations',
  'hn.dl.absentDone': 'Marked absent today · backup takes over from 09:14',
  'hn.dl.absent': 'Mark absent today',
  'hn.dl.absentNow': 'Absent today · backup takes over from 09:14',
  'hn.dl.undone': 'Absence cancelled · tasks return to you',
  'hn.dl.cancel': 'Cancel absence',
  'hn.dl.none': 'You are not covering for anyone.',
  'hn.dl.period': 'Tasks this period',
  'hn.overdue': 'Overdue',
  'hn.doneL': 'Done',
  'hn.dl.born': 'Tasks arising while covering · KPI counted for the cover',
  'hn.dk.ask': 'Ask Hana ›',
  'hn.dk.deleg': 'Delegation: covering TUANNT, PHONGNT · 6 tasks',
  'hn.dk.mailL': 'Open mail {m}',
  'hn.open': 'Open',
  'hn.dk.noNoti': 'No notifications.',
  'hn.dk.readAllDone': 'All marked as read',
  'hn.dk.noAp': 'No requests awaiting your approval.',
  'hn.dk.approve': 'Approve',
  'hn.gv.title': 'Tasks I assigned / follow',
  'hn.gv.open': 'open',
  'hn.gv.assign': 'Assign task',
  'hn.gv.none': 'No tasks here yet.',
  'hn.gv.recalled': '{c} recalled to you',
  'hn.gv.recall': 'Recall',
  'hn.nw.kick': 'INTERNAL NEWS',
  'hn.nw.next': 'Next news',
  'hn.nw.prev': 'Previous news',
  'hn.nw.openBanner': 'Open banner',
  'hn.nw.none': 'No news for this audience / category.',
  'hn.nw.write': 'Write news',
  'hn.sd.cal': 'Today\'s schedule',
  'hn.sd.calSub': 'my tasks + cut-off',
  'hn.sd.today': 'Today',
  'hn.sd.h48': '48 hours',
  'hn.sd.noMark': 'No milestones in this range.',
  'hn.sd.sla': 'SLA & overdue',
  'hn.sd.slaSub': 'my tasks · 30 days',
  'hn.sd.byGrp': 'Open tasks by group',
  'hn.sd.esc': 'Escalated to me',
  'hn.sd.src': 'Tasks by source',
  'hn.sd.srcSub': 'open tasks',
  'hn.sd.noOpen': 'No open tasks.',
  'hn.sd.noItem': 'Nothing to handle.',
  'hn.tm.title': 'Team tasks · by person',
  'hn.tm.sum': '{n} people · {o} overdue',
  'hn.tm.ok': 'on time',
  'hn.tm.over': 'overdue',
  'hn.tm.wait': 'waiting',
  'hn.tm.none': 'No team data yet.',
  'hn.tm.openL': 'open',
  'hn.tm.late': 'late',
  'hn.tm.of': '{p}\'s tasks',
  'hn.tm.closeL': 'Close person\'s tasks',
  'hn.tm.reDone': 'reassigned',
  'hn.tm.reTip': 'Reassigned',
  'hn.tm.re': 'Reassign…',
  'hn.ap.k.all': 'All',
  'hn.ap.k.money': 'Money & receivables',
  'hn.ap.k.hr': 'HR',
  'hn.ap.k.other': 'Other',
  'hn.ap.d.ok': '✓ Approved',
  'hn.ap.d.no': 'Rejected',
  'hn.ap.d.ask': 'Asked for more info',
  'hn.ap.sumOld': '{n} requests · oldest {d} days',
  'hn.ap.sum': '{n} requests',
  'hn.ap.bySeat': 'By seat',
  'hn.ap.allSeats': 'All seats',
  'hn.ap.power': ' (power)',
  'hn.ap.expand': 'Expand Awaiting my approval',
  'hn.ap.kindL': 'Request type',
  'hn.ap.findL': 'Search requests',
  'hn.ap.findPh': 'Search requests…',
  'hn.ap.bulk': 'Bulk approve',
  'hn.ap.picked': '{n} requests selected',
  'hn.ap.noBulk': '{n} requests must be opened one by one and are excluded from bulk approval',
  'hn.ap.nextStep': 'Each request moves to its next step',
  'hn.ap.rejectN': 'Reject {n}',
  'hn.ap.agreedN': 'Approved {n} requests',
  'hn.ap.agreeN': 'Approve {n} requests',
  'hn.ap.noMatch': 'No requests match the filter.',
  'hn.ap.none': 'No requests awaiting your approval.',
  'hn.ap.openSrc': 'Open source document',
  'hn.ap.by': 'requested by',
  'hn.ap.step': 'Step {i}/{n}',
  'hn.ap.by2': 'Requested by',
  'hn.ap.sentAt': 'Sent at',
  'hn.ap.seeMore': 'See {n} more requests ›',
});

// Bảng phải 1920 (Dock) — nhãn tab, nhóm việc, mail hộp chung.
addMessages('vi', {
  'hn.dk.tabTask': 'Việc', 'hn.dk.tabNoti': 'Thông báo', 'hn.dk.tabAp': 'Duyệt',
  'hn.dk.grpOver': 'Quá hạn', 'hn.dk.grpToday': 'Hôm nay', 'hn.dk.grpNext': 'Sắp tới',
  'hn.dk.doneC': 'Đã xong {c}', 'hn.dk.extL': 'Gia hạn 4 giờ', 'hn.dk.extT': 'Gia hạn +4 giờ · {x}',
  'hn.dk.mailH': 'Mail hộp chung · {n} chưa xử lý', 'hn.dk.mailDone': 'Đã xử lý: {m}',
});
addMessages('en', {
  'hn.dk.tabTask': 'Tasks', 'hn.dk.tabNoti': 'Notifications', 'hn.dk.tabAp': 'Approvals',
  'hn.dk.grpOver': 'Overdue', 'hn.dk.grpToday': 'Today', 'hn.dk.grpNext': 'Upcoming',
  'hn.dk.doneC': 'Done {c}', 'hn.dk.extL': 'Extend 4 hours', 'hn.dk.extT': 'Extend +4 hours · {x}',
  'hn.dk.mailH': 'Shared mailbox · {n} unprocessed', 'hn.dk.mailDone': 'Processed: {m}',
});

// Việc tôi giao (Given).
addMessages('vi', {
  'hn.gv.aria': 'Việc tôi giao', 'hn.gv.expandL': 'Mở rộng Việc tôi giao', 'hn.gv.viewL': 'Xem',
  'hn.gv.tabMine': 'Tôi giao {n}', 'hn.gv.tabFol': 'Đang theo dõi {n}',
  'hn.gv.unfol': 'Bỏ theo dõi', 'hn.gv.follow': 'Theo dõi',
  'hn.gv.unfolDone': 'Đã bỏ theo dõi {c}', 'hn.gv.folDone': 'Đang theo dõi {c} · nhận thông báo khi đổi trạng thái',
  'hn.gv.sub': '{o} · giao {w} · hạn {d}', 'hn.gv.nudged': 'Đã nhắc {w} · {c}',
  'hn.gv.nudge': 'Nhắc', 'hn.gv.nudgeN': 'Nhắc · {n}',
});
addMessages('en', {
  'hn.gv.aria': 'Tasks I assigned', 'hn.gv.expandL': 'Expand Tasks I assigned', 'hn.gv.viewL': 'View',
  'hn.gv.tabMine': 'Assigned by me {n}', 'hn.gv.tabFol': 'Following {n}',
  'hn.gv.unfol': 'Unfollow', 'hn.gv.follow': 'Follow',
  'hn.gv.unfolDone': 'Unfollowed {c}', 'hn.gv.folDone': 'Following {c} · you will be notified on status changes',
  'hn.gv.sub': '{o} · assigned to {w} · due {d}', 'hn.gv.nudged': 'Reminded {w} · {c}',
  'hn.gv.nudge': 'Remind', 'hn.gv.nudgeN': 'Remind · {n}',
});

// Chuỗi còn lại của Trang chủ: nhãn trợ năng, tooltip, đếm (Team · News · Side).
addMessages('vi', {
  'hn.tm.aria': 'Việc của team', 'hn.tm.expandL': 'Mở rộng Việc của team', 'hn.tm.expand': 'Mở rộng',
  'hn.tm.unTip': 'Trưởng bộ phận mở tạm 2h có ghi lý do; mọi lần mở vào nhật ký',
  'hn.tm.unDone': 'Đã mở tạm 2h · ghi nhật ký', 'hn.tm.un2': 'Mở tạm 2h', 'hn.tm.unWarn': 'Cảnh báo · mở tạm',
  'hn.tm.unDid': 'đã mở tạm 2h', 'hn.tm.free': 'Không chặn',
  'hn.nw.album': 'Xem album', 'hn.nw.read': 'Đọc bài', 'hn.nw.miniAria': 'Tin nội bộ (thu gọn)', 'hn.nw.noNews': 'Không có tin',
  'hn.nw.aria': 'Tin nội bộ', 'hn.nw.carousel': 'trình chiếu', 'hn.nw.photos': '{n} ảnh', 'hn.nw.tagTip': 'Lọc tin theo tag #{g}',
  'hn.nw.views': '{n} lượt xem', 'hn.nw.sendTo': 'Gửi:', 'hn.nw.play': 'Chạy trình chiếu', 'hn.nw.pause': 'Tạm dừng trình chiếu',
  'hn.nw.item': 'Tin {n}', 'hn.nw.audL': 'Đối tượng', 'hn.nw.catL': 'Danh mục', 'hn.nw.fold': 'Thu gọn banner tin',
  'hn.sd.calAria': 'Lịch hôm nay', 'hn.sd.overN': '{n} quá hạn', 'hn.sd.rangeL': 'Khoảng lịch',
  'hn.sd.gone': '{n} mốc đã qua', 'hn.sd.later': '{n} mốc sau', 'hn.sd.tmrDay': 'Mai 23/Oct',
  'hn.sd.slaAria': 'SLA và quá hạn', 'hn.sd.gaugeL': 'Việc của tôi đúng hạn 30 ngày {p}%', 'hn.sd.trendL': 'Đúng hạn 6 tuần: {v}',
  'hn.sd.srcAria': 'Việc theo nguồn', 'hn.sd.srcL': 'Việc mở theo nguồn: {v}',
  'hn.sd.arT': 'Khách quá hạn nợ', 'hn.sd.arN': '{n} khách', 'hn.sd.qtT': 'Báo giá sắp hết hạn & hỏi giá chờ',
});
addMessages('en', {
  'hn.tm.aria': 'Team tasks', 'hn.tm.expandL': 'Expand Team tasks', 'hn.tm.expand': 'Expand',
  'hn.tm.unTip': 'Department head unlocks for 2h with a reason; every unlock is logged',
  'hn.tm.unDone': 'Unlocked for 2h · logged', 'hn.tm.un2': 'Unlock 2h', 'hn.tm.unWarn': 'Warning · unlock',
  'hn.tm.unDid': 'unlocked 2h', 'hn.tm.free': 'Not blocked',
  'hn.nw.album': 'View album', 'hn.nw.read': 'Read', 'hn.nw.miniAria': 'Company news (collapsed)', 'hn.nw.noNews': 'No news',
  'hn.nw.aria': 'Company news', 'hn.nw.carousel': 'carousel', 'hn.nw.photos': '{n} photos', 'hn.nw.tagTip': 'Filter news by tag #{g}',
  'hn.nw.views': '{n} views', 'hn.nw.sendTo': 'To:', 'hn.nw.play': 'Play slideshow', 'hn.nw.pause': 'Pause slideshow',
  'hn.nw.item': 'News {n}', 'hn.nw.audL': 'Audience', 'hn.nw.catL': 'Category', 'hn.nw.fold': 'Collapse news banner',
  'hn.sd.calAria': "Today's calendar", 'hn.sd.overN': '{n} overdue', 'hn.sd.rangeL': 'Calendar range',
  'hn.sd.gone': '{n} past', 'hn.sd.later': '{n} later', 'hn.sd.tmrDay': 'Tmrw 23/Oct',
  'hn.sd.slaAria': 'SLA and overdue', 'hn.sd.gaugeL': 'My on-time rate, 30 days: {p}%', 'hn.sd.trendL': 'On-time, 6 weeks: {v}',
  'hn.sd.srcAria': 'Tasks by source', 'hn.sd.srcL': 'Open tasks by source: {v}',
  'hn.sd.arT': 'Overdue customers', 'hn.sd.arN': '{n} customers', 'hn.sd.qtT': 'Quotes expiring & pending rate requests',
});
